import $ from "jquery";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layouts/Header";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import FormNamePopup from "./FormNamePopup";
import pdfIcon from "../../assets/icons/Pdf icon blur.svg";
import printIcon from "../../assets/icons/Print icon blur.svg";
import duplicateIcon from "../../assets/icons/Duplicate blur.svg";
import refreshIcon from "../../assets/icons/refresh icon.svg";
import LeftArrowCircle from "../../assets/icons/LeftArrowCircle.svg";
import "../Form_Builder_POC/FormBuilderPOC.css";

import { ReactFormBuilder, ElementStore, Registry } from "react-form-builder2";
import "react-form-builder2/dist/app.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Import custom components
// import CustomComponent from "../Form_Builder_POC/CustomComponent";

window.jQuery = $;
window.$ = $;

require("jquery-ui-sortable");
require("formBuilder/dist/form-builder.min.js");

const formData = [
  {
    type: "header",
    subtype: "h1",
    label: "formBuilder in React",
  },
  {
    type: "paragraph",
    label: "This is a demonstration of formBuilder running in a React project.",
  },
];

const FormBuilderPOC2 = () => {
  // ASC its main link for Form Builder POC start.
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css";
    link.integrity =
      "sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh";
    link.crossOrigin = "anonymous";

    // Append to head
    document.head.appendChild(link);

    // Clean up function to remove link on component unmount
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  // ASC its main link for Form Builder POC end.

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const params = useParams();
  const formPOCid = params.id;
  console.log("param", params.id);

  const fb = useRef(null);

  // state start from here 👇
  const [formBuilder, setFormBuilder] = useState(null);

  // function start from here 👇
  const handleSubmit = () => {
    if (formBuilder) {
      const data = formBuilder.actions.getData("json"); // Get the form data in JSON format
      console.log("asc562 Form Data:", JSON.parse(data)); // Log the form data to the console
    }
  };

  useEffect(() => {
    const options = { formData };
    // $(fb.current).formBuilder(options);
    const fbInstance = $(fb.current).formBuilder(options);
    setFormBuilder(fbInstance);
  }, []);

  return (
    <div className="bg-gray-100 p-4">
      <div className="bg-white p-4 rounded-md shadow-md">
        <div className="alert alert-info mb-4">
          This is an example of how to use formBuilder with React. The JSON data
          for this form was set programmatically.
          {/* Implemented by ASC form Builder. */}
        </div>
        <div id="fb-editor" ref={fb} />

        {/* if want, otherwise remove div start*/}
        <div className="mt-4">
          <button className="btn btn-primary mr-2" onClick={handleSubmit}>
            Submit Form
          </button>
          <button className="btn btn-secondary mr-2" onClick={handleSubmit}>
            Preview Form
          </button>
          <button className="btn btn-success" onClick={handleSubmit}>
            Add Toolbox Item
          </button>
        </div>
        {/* if want, otherwise remove div end*/}
      </div>
    </div>
  );
};

export default FormBuilderPOC2;
